export const getArrayFromString = function(stringToSplit: string) {
  return stringToSplit.split(',').map(text => text.trim());
};



// WEBPACK FOOTER //
// /Users/abeltrotter/Documents/git/epicodus/javascript/portfolio-angular/src/app/util/util.ts